
































































import Vue from 'vue';
import ChipFeatureFlag from '@/components/ChipFeatureFlag.vue';

export default Vue.extend({
  props: ['item', 'route'],
  components: { ChipFeatureFlag },
  methods: {
    onChildClick(child: any) {
      child && child.onClick && child.onClick();
    },
  },
});
